import "./Header.css";
import imgLogo from "../../assets/logo.png";
import PropTypes from 'prop-types';


export const Header = ({ msisdn }) => {
 
  return (
    <div className={`container__header`}>
      <div className="container__header__logo">
        <img
          className="logo__header__telcel"
          src={imgLogo}
          alt="logo telcel"
      
        />
      </div>
      <div className="container__header__number">
        {msisdn && (
          <p >{`Hola, ${
            msisdn ? msisdn.substr(-10) : ""
          }`}</p>
        )}
      </div>
    
    </div>
  );
};

Header.propTypes = {
  msisdn: PropTypes.string
};